import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "number",
  "description",
  "manufacturer",
  "on_hand",
  "usable",
  "reserved",
  "available",
  "condition",
  "facility",
  "work_orders",
  "unit_of_measure",
  "unit_cost",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const DEFAULT_COLUMNS: Column[] = [
  "number",
  "description",
  "on_hand",
  "usable",
  "reserved",
  "available",
]

export const COLUMN_LABELS: Record<Column, string> = {
  number: "Part no.",
  description: "Description",
  manufacturer: "Manufacturer",
  on_hand: "On hand",
  usable: "Usable",
  reserved: "Reserved",
  available: "Available",
  condition: "Condition",
  facility: "Facility",
  work_orders: "Work orders",
  unit_of_measure: "UoM",
  unit_cost: "Unit cost",
}

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "inventory",
  widths: {
    select: 2.25,
    number: 9,
    description: 12,
    manufacturer: 8,
    on_hand: 6,
    usable: 6,
    reserved: 6,
    available: 6,
    condition: 7,
    facility: 7,
    work_orders: 9,
    unit_of_measure: 4,
    unit_cost: 7,
    status: 2,
    actions: 3.25,
  },
  fill: "description",
  pinned: ["select", "status", "actions"],
  extras: ["select", "status", "actions"],
  dropOrder: [
    "unit_of_measure",
    "unit_cost",
    "facility",
    "condition",
    "manufacturer",
    "work_orders",
    "reserved",
    "on_hand",
    "usable",
    "available",
  ],
}

export const HOLDER_COLUMN: Column = "work_orders"

export type Slot = Column | "select" | "status" | "actions"

export function withPartNumber(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => column === "number" || columns.includes(column),
  )
}

export function slotsOf(columns: Column[], selectable: boolean): Slot[] {
  const rest = COLUMNS.filter(
    (column) => column !== "number" && columns.includes(column),
  )
  const shown: Slot[] = ["number", "status", ...rest, "actions"]
  return selectable ? ["select", ...shown] : shown
}
